import { render, staticRenderFns } from "./CellFormat.vue?vue&type=template&id=6bb404dd&scoped=true&"
import script from "./CellFormat.vue?vue&type=script&lang=js&"
export * from "./CellFormat.vue?vue&type=script&lang=js&"
import style0 from "./CellFormat.vue?vue&type=style&index=0&id=6bb404dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb404dd",
  null
  
)

export default component.exports